export default "__VITE_ASSET__D$ooaubm__"